<template>
  <div id="unitImages" style="cursor: pointer">
    <div  class="swiper-container CompanyCard w margin">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in images" :key="index" class="swiper-slide">
          <img v-img class="blogSliderImage" :src="item" alt="blog image" />
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
// import "swiper/css/autoplay";
import image from "../../assets/images/factorybox3.jpg";
import Swiper from "swiper/swiper-bundle.min";
let breakpoints = {
  300: {
    slidesPerView: 1,
    spaceBetween: 40,
    centeredSlides: true,
  },
  370: {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: true,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 1,
  },
  1200: {
    slidesPerView: 4,
    spaceBetween: 10,
  },
};
export default {


  computed: {
    modules() {
      return [Autoplay];
    },
  },
  props: {
    images: Array,
  },
  computed: {
    modules() {
      return [Autoplay];
    },
  },
  mounted() {
    this.initSlider(false);
  },
  methods: {
    initSlider(kill = false) {
      this.$root.initSwiper("unitImagesSlider", kill, () => {
        try {
          if (this.slider) {
            this.slider.destroy();
          }
        } catch (e) {}
        this.slider = new Swiper("#unitImages .swiper-container", {
          spaceBetween: 1,
      
          loop: false,
          speed: 500,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          autoplay: false,

          breakpoints,
        });
      });
    },
  },
  data() {
    return {
      slider: null,

      settings: {
        dots: false,
        arrow: true,
        infinite: false,
        centerPadding: "20px",
        autoplay: false,
        slidesToShow: 4,
        adaptiveHeight: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "20px",
              initialSlide: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "20px",
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: "20px",
              initialSlide: 2,
              infinite: false,

              slidesToScroll: 1,
            },
          },
        ],
      },
      boximages: 10,
      Image: image,
      breakpoints: {
        1025: {
          slidesPreview: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPreview: 2,
          spaceBetween: 30,
        },
        420: {
          slidesPreview: 1,
          spaceBetween: 30,
        },
      },
    };
  },
};
</script>
<style scoped>
.BlogSlider {
  display: flex;
  padding: 2rem 0;
}
#unitImages .swiper-wrapper{
  align-items: center;
}
.blogSliderImage {
  width: 100%;
  /* height: 400px; */
  padding: 0 10px;
}
.TopBlogSlider {
  width: 96%;
  margin: auto;
}
</style>
